import 'PackWerkNurikaeSite/pages/home/index/partials/top_prefecture_company_ranking/component.scss'
import './images/crown.svg'
import './images/arrow_orange.svg'
import './images/separator_bar.svg'
import './images/separator_orange.svg'
import 'PackWerkNurikaeSite/pages/home/index/partials/top_prefecture_company_ranking/company_ranking_card/component'
import 'Components/site/company_card_ribbon/component'
import { Controller } from 'stimulus'
import { Splide } from '@splidejs/splide'
import '@splidejs/splide/css'

class TopPrefectureCompanyRankingController extends Controller {
  static targets = [
    'prefectureDropdownTrigger',
    'cityDropdownTrigger',
    'rankingDropdownTrigger',
    'prefectureDropdown',
    'cityDropdown',
    'rankingDropdown',
    'prefectureDropdownMenu',
    'cityDropdownMenu',
    'rankingDropdownMenu',
    'prefectureLabel',
    'cityLabel',
    'rankingLabel',
    'prefectureList',
    'cityList',
    'rankingList',
    'companiesContainer',
    'loading',
    'sliderContainer',
    'companiesLink',
    'prefectureName',
    'rankingLabelElement',
    'totalCount'
  ]

  static values = {
    endpoint: String,
    defaultPrefectureId: String,
    defaultRankingType: String
  }

  static classes = ['active', 'selected', 'loading', 'disabled']

  connect() {
    // URLパラメータから初期値を取得
    const urlSearchParams = new URLSearchParams(window.location.search)
    const prefectureIdFromUrl = urlSearchParams.get('prefecture_id')
    const rankingTypeFromUrl = urlSearchParams.get('ranking_type')

    // 初期値を設定（通常のプロパティとして）
    this.currentPrefectureId = prefectureIdFromUrl || this.defaultPrefectureIdValue
    this.currentRankingType = rankingTypeFromUrl || this.defaultRankingTypeValue
    this.currentCityId = ''
    this.currentCompanyCount = 0

    // CSS Custom Propertiesから値を取得
    this.breakpoints = this.getBreakpointsFromCSS()
    this.sliderConfig = this.getSliderConfigFromCSS()

    // Splideインスタンスを格納
    this.splideInstance = null

    // 元のHTMLを保持（リサイズ時の再構築用）
    this.originalHtml = null

    // ドロップダウン外のクリックで閉じる
    this.boundClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundClickOutside)

    // ウィンドウリサイズイベント
    this.boundResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.boundResize)

    // 初期化処理（値が設定された後に実行）
    this.setSelectedPrefecture(this.currentPrefectureId)
    this.setSelectedRankingType(this.currentRankingType)

    // 初期表示の更新
    this.updatePrefectureNameDisplay()
    this.updateRankingLabelDisplay()

    // デフォルト都道府県の市区町村を読み込み
    if (this.currentPrefectureId) {
      this.loadCitiesByPrefecture(this.currentPrefectureId)
    }

    this.loadCompanies()
  }

  disconnect() {
    // イベントリスナーのクリーンアップ
    document.removeEventListener('click', this.boundClickOutside)
    window.removeEventListener('resize', this.boundResize)

    // Splideインスタンスの破棄
    if (this.splideInstance) {
      this.splideInstance.destroy()
      this.splideInstance = null
    }
  }

  // ドロップダウントリガーのアクション
  togglePrefectureDropdown(event) {
    event.stopPropagation()
    this.toggleDropdown(
      this.prefectureDropdownTarget,
      this.prefectureDropdownMenuTarget,
      'prefecture'
    )
  }

  toggleCityDropdown(event) {
    event.stopPropagation()
    this.toggleDropdown(
      this.cityDropdownTarget,
      this.cityDropdownMenuTarget,
      'city'
    )
  }

  toggleRankingDropdown(event) {
    event.stopPropagation()
    this.toggleDropdown(
      this.rankingDropdownTarget,
      this.rankingDropdownMenuTarget,
      'ranking'
    )
  }

  // ドロップダウンの開閉
  toggleDropdown(dropdown, menu, type) {
    if (menu.classList.contains(this.activeClass)) {
      this.closeDropdown(dropdown, menu)
    } else {
      // 他のドロップダウンを閉じる
      this.closeOtherDropdowns(type)
      this.openDropdown(dropdown, menu)
    }
  }

  // 指定したドロップダウン以外を閉じる
  closeOtherDropdowns(exceptType) {
    if (exceptType !== 'prefecture') {
      this.closeDropdown(
        this.prefectureDropdownTarget,
        this.prefectureDropdownMenuTarget
      )
    }
    if (exceptType !== 'city') {
      this.closeDropdown(
        this.cityDropdownTarget,
        this.cityDropdownMenuTarget
      )
    }
    if (exceptType !== 'ranking') {
      this.closeDropdown(
        this.rankingDropdownTarget,
        this.rankingDropdownMenuTarget
      )
    }
  }

  openDropdown(dropdown, menu) {
    menu.classList.add(this.activeClass)
    dropdown.classList.add(this.activeClass)
  }

  closeDropdown(dropdown, menu) {
    menu.classList.remove(this.activeClass)
    dropdown.classList.remove(this.activeClass)
  }

  // ドロップダウン外クリックで閉じる
  handleClickOutside(event) {
    if (!event.target.closest('.js-ranking-prefecture-dropdown')) {
      this.closeDropdown(
        this.prefectureDropdownTarget,
        this.prefectureDropdownMenuTarget
      )
    }
    if (!event.target.closest('.js-ranking-city-dropdown')) {
      this.closeDropdown(
        this.cityDropdownTarget,
        this.cityDropdownMenuTarget
      )
    }
    if (!event.target.closest('.js-ranking-type-dropdown')) {
      this.closeDropdown(
        this.rankingDropdownTarget,
        this.rankingDropdownMenuTarget
      )
    }
  }

  // 都道府県選択
  selectPrefecture(event) {
    event.stopPropagation()
    const listItem = event.currentTarget
    this.currentPrefectureId = listItem.dataset.value

    this.prefectureLabelTarget.textContent = listItem.textContent
    this.prefectureDropdownTriggerTarget.classList.add(this.selectedClass)

    // 市区町村リストをリセット
    this.currentCityId = ''
    this.resetCityDropdown()

    // 都道府県名の表示を更新
    this.updatePrefectureNameDisplay()

    // 市区町村リストを取得・更新
    this.loadCitiesByPrefecture(this.currentPrefectureId)

    this.closeDropdown(
      this.prefectureDropdownTarget,
      this.prefectureDropdownMenuTarget
    )
    this.loadCompanies()
  }

  // 市区町村選択
  selectCity(event) {
    event.stopPropagation()
    const listItem = event.currentTarget

    // 無効な市区町村は選択できない
    if (listItem.dataset.enabled !== 'true') {
      return
    }

    this.currentCityId = listItem.dataset.value

    this.cityLabelTarget.textContent = listItem.textContent
    this.cityDropdownTriggerTarget.classList.add(this.selectedClass)

    // 市区町村名の表示を更新
    this.updatePrefectureNameDisplay()

    this.closeDropdown(
      this.cityDropdownTarget,
      this.cityDropdownMenuTarget
    )
    this.loadCompanies()
  }

  // ランキング種別選択
  selectRanking(event) {
    event.stopPropagation()
    const listItem = event.currentTarget
    this.currentRankingType = listItem.dataset.value

    this.rankingLabelTarget.textContent = listItem.textContent
    this.rankingDropdownTriggerTarget.classList.add(this.selectedClass)

    // ランキングラベルを更新
    this.updateRankingLabelDisplay()

    this.closeDropdown(
      this.rankingDropdownTarget,
      this.rankingDropdownMenuTarget
    )
    this.loadCompanies()
  }

  setSelectedPrefecture(prefectureId) {
    if (!this.hasPrefectureListTarget || !this.hasPrefectureLabelTarget) return

    const prefectureItem = this.prefectureListTarget.querySelector(
      `[data-value="${prefectureId}"]`
    )
    if (prefectureItem) {
      this.prefectureLabelTarget.textContent = prefectureItem.textContent
      this.prefectureDropdownTriggerTarget.classList.add(this.selectedClass)
    }
  }

  setSelectedRankingType(rankingType) {
    if (!this.hasRankingListTarget || !this.hasRankingLabelTarget) return

    const rankingItem = this.rankingListTarget.querySelector(
      `[data-value="${rankingType}"]`
    )
    if (rankingItem) {
      this.rankingLabelTarget.textContent = rankingItem.textContent
      this.rankingDropdownTriggerTarget.classList.add(this.selectedClass)
    }
  }

  resetCityDropdown() {
    if (this.hasCityLabelTarget) {
      this.cityLabelTarget.textContent = '市区町村'
      this.cityDropdownTriggerTarget.classList.remove(this.selectedClass)
    }

    if (this.hasCityListTarget) {
      this.cityListTarget.innerHTML = ''
    }

    // 市区町村がリセットされたので都道府県名を表示
    this.updatePrefectureNameDisplay()
  }

  async loadCitiesByPrefecture(prefectureId) {
    if (!prefectureId) return

    try {
      // 都道府県名を取得
      if (!this.hasPrefectureLabelTarget) return

      const prefectureName = this.prefectureLabelTarget.textContent.trim()

      // APIから市区町村リストを取得
      const response = await fetch(
        `/api/prefecture/${prefectureName}/enable_cities_for_part_type/?part_type_url=exterior_outer-wall`
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const cities = await response.json()
      this.renderCitiesList(cities)
    } catch (error) {
      // エラー時は市区町村リストを空にする
      this.resetCityDropdown()
    }
  }

  renderCitiesList(cities) {
    if (!this.hasCityListTarget || !cities || cities.length === 0) return

    // APIレスポンスの構造に合わせて市区町村リストを作成
    const citiesHtml = cities
      .map((city) => {
        const enabledClass = city.enabled
          ? 'top-prefecture-company-ranking__city-item--enabled'
          : 'top-prefecture-company-ranking__city-item--disabled'
        return `<li class="top-prefecture-company-ranking__city-item ${enabledClass}" data-value="${city.id}" data-enabled="${city.enabled}" data-action="click->nurikae-site--pages--home--index--partials--top-prefecture-company-ranking#selectCity">${city.name}</li>`
      })
      .join('')

    this.cityListTarget.innerHTML = citiesHtml
  }

  async loadCompanies() {
    if (!this.currentPrefectureId || !this.currentRankingType) {
      this.renderError()
      return
    }

    this.buildLinkUrl()
    this.showLoading()

    try {
      const params = new URLSearchParams({
        prefecture_id: this.currentPrefectureId,
        ranking_type: this.currentRankingType
      })

      // 市区町村が選択されている場合はパラメータに追加
      if (this.currentCityId && this.currentCityId !== '') {
        params.append('city_id', this.currentCityId)
      }

      const url = `${this.endpointValue}?${params}`

      const response = await fetch(url)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.error) {
        throw new Error(data.error)
      }

      // 会社数を更新
      this.currentCompanyCount = data.total_count || 0
      this.updateCompanyCountDisplay()
      this.updateMoreLinkState()

      this.renderCompaniesFromHtml(data.html)
    } catch (error) {
      this.currentCompanyCount = 0
      this.updateCompanyCountDisplay()
      this.updateMoreLinkState()
      this.renderError()
    } finally {
      this.hideLoading()
    }
  }

  renderCompaniesFromHtml(html) {
    if (!html || html.trim() === '') {
      this.currentCompanyCount = 0
      this.updateCompanyCountDisplay()
      this.updateMoreLinkState()
      this.companiesContainerTarget.innerHTML =
        '<p class="top-prefecture-company-ranking__no-data">該当する会社が見つかりませんでした。</p>'
      return
    }

    // 既存のSplideインスタンスを破棄
    if (this.splideInstance) {
      this.splideInstance.destroy()
      this.splideInstance = null
    }

    // 元のHTMLを保存
    this.originalHtml = html
    // 画面サイズによってHTML構造を切り替え
    this.renderByScreenSize()
    // DOM更新を確実に完了させるための遅延
    setTimeout(() => {
      this.initializeSlider()
    }, 0)
  }

  renderByScreenSize() {
    if (!this.originalHtml) return

    if (window.innerWidth <= this.breakpoints.tablet) {
      // .splideクラスを追加（Splide用）
      this.companiesContainerTarget.classList.add('splide')

      // タブレット・SP: Splide用のHTML構造を作成
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = this.originalHtml
      const companyItems = tempDiv.children

      // 各アイテムにsplide__slideクラスを追加
      Array.from(companyItems).forEach((item) => {
        item.classList.add('splide__slide')
      })

      // Splide用のHTMLラッパーを作成
      const splideHtml = `
        <div class="splide__track">
          <div class="splide__list">
            ${tempDiv.innerHTML}
          </div>
        </div>
      `

      this.companiesContainerTarget.innerHTML = splideHtml
    } else {
      // .splideクラスを削除（通常表示用）
      this.companiesContainerTarget.classList.remove('splide')
      // PC: 通常のHTML構造をそのまま表示
      this.companiesContainerTarget.innerHTML = this.originalHtml
    }
  }

  renderError() {
    this.companiesContainerTarget.innerHTML =
      '<p class="top-prefecture-company-ranking__error">データの読み込みに失敗しました。時間をおいて再度お試しください。</p>'
  }

  showLoading() {
    this.loadingTarget.classList.add(this.loadingClass)
  }

  hideLoading() {
    this.loadingTarget.classList.remove(this.loadingClass)
  }

  initializeSlider() {
    // 現在の画面幅をチェック
    if (window.innerWidth <= this.breakpoints.tablet) {
      const splideOptions = {
        speed: this.sliderConfig.speed,
        perMove: 1,
        perPage: 1,
        gap: '12px',
        padding: this.sliderConfig.centerPadding,
        focus: 'center'
      }

      this.splideInstance = new Splide(
        this.companiesContainerTarget,
        splideOptions
      )
      this.splideInstance.mount()
    }
  }

  handleResize() {
    // データロード前のリサイズは無視
    if (!this.originalHtml) {
      return
    }

    // 既存のSplideインスタンスを破棄
    if (this.splideInstance) {
      this.splideInstance.destroy()
      this.splideInstance = null
    }

    // HTMLをサイズに応じて再レンダリング
    this.renderByScreenSize()
    // スライダーを初期化（必要な場合のみ）
    this.initializeSlider()
  }

  getBreakpointsFromCSS() {
    if (!this.hasSliderContainerTarget) return { tablet: 768, sp: 576 }

    const styles = getComputedStyle(this.sliderContainerTarget)
    return {
      tablet:
        parseInt(styles.getPropertyValue('--slider-tablet-breakpoint')) || 768,
      sp: parseInt(styles.getPropertyValue('--slider-sp-breakpoint')) || 576
    }
  }

  getSliderConfigFromCSS() {
    if (!this.hasSliderContainerTarget)
      return { speed: 800, centerPadding: '30px' }

    const styles = getComputedStyle(this.sliderContainerTarget)
    return {
      speed: parseInt(styles.getPropertyValue('--slider-speed')) || 800,
      centerPadding: styles.getPropertyValue('--slider-center-padding') || '30px'
    }
  }

  updateCompanyCountDisplay() {
    if (this.hasTotalCountTarget) {
      this.totalCountTarget.textContent = `${this.currentCompanyCount}社`
    }
  }

  updatePrefectureNameDisplay() {
    if (!this.hasPrefectureNameTarget) return

    // 市区町村が選択されている場合は市区町村名を表示
    if (this.currentCityId && this.currentCityId !== '') {
      if (
        this.hasCityLabelTarget &&
        this.cityLabelTarget.textContent !== '市区町村'
      ) {
        this.prefectureNameTarget.textContent = this.cityLabelTarget.textContent
        return
      }
    }

    // 都道府県のみ選択されている場合は都道府県名を表示
    if (this.hasPrefectureLabelTarget) {
      this.prefectureNameTarget.textContent = this.prefectureLabelTarget.textContent
    }
  }

  updateRankingLabelDisplay() {
    if (!this.hasRankingLabelElementTarget) return

    // ランキング種別に応じてラベルを更新
    const rankingLabel = this.getRankingLabelForType(
      this.currentRankingType
    )
    this.rankingLabelElementTarget.textContent = rankingLabel
  }

  getRankingLabelForType(rankingType) {
    switch (rankingType) {
      case 'reviews_count_desc':
        return '口コミ数'
      case 'rate_average_desc':
        return '口コミ評価'
      case 'examples_count_desc':
        return '事例数'
      case 'construction_count_desc':
        return '工事件数'
      default:
        return '口コミ数'
    }
  }

  updateMoreLinkState() {
    if (!this.hasCompaniesLinkTarget) return

    if (this.currentCompanyCount === 0) {
      // 会社が0件の場合はリンクを無効化
      this.companiesLinkTarget.classList.add(this.disabledClass)
      this.companiesLinkTarget.style.pointerEvents = 'none'
      this.companiesLinkTarget.style.opacity = '0.5'
      this.companiesLinkTarget.removeAttribute('href')
    } else {
      // 会社が存在する場合はリンクを有効化
      this.companiesLinkTarget.classList.remove(this.disabledClass)
      this.companiesLinkTarget.style.pointerEvents = ''
      this.companiesLinkTarget.style.opacity = ''
      this.buildLinkUrl()
    }
  }

  buildLinkUrl() {
    if (!this.hasPrefectureLabelTarget || !this.hasCompaniesLinkTarget) return

    const prefectureName = encodeURIComponent(
      this.prefectureLabelTarget.textContent
    )
    const orderType = this.currentRankingType
    let url = `/area/${prefectureName}`

    // 市区町村が選択されている場合はURLに追加
    if (this.currentCityId && this.currentCityId !== '') {
      url += `/${this.currentCityId}`
    } else {
      url += '/part'
    }

    url += `/exterior_outer-wall${orderType === 'construction_count_desc' ? '' : `?order=${orderType}`}`

    this.companiesLinkTarget.href = url
  }
}

// StimulusJSに登録
window.Stimulus.register('nurikae-site--pages--home--index--partials--top-prefecture-company-ranking', TopPrefectureCompanyRankingController)
